<template>
	<div id="cc_right1">
		<div class="cc-header">今日学生出勤
			<div class="title_tab">
				<div class="legend-color" style="background-color: #32ceb7;"></div>应出勤
				<div class="legend-color" style="background-color: #ffbe3c;margin-left: 0.1rem;"></div>实际出勤
			</div>
			<div class="view_btn" @click="showTable">查看明细</div>
		</div>
		<div class="main-value" id="mess_info"></div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
let pageSize = 8; //echarts每页显示数量
let attendInfoByTodayChart;
export default {
	data() {
		return {
			start: 0,
			end: pageSize - 1,
			total: 0
		};
	},
	mounted() {
		this.initData();
		// 定时器刷新，30分钟
		let _this = this;
		setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 30);
		// 定时器轮播，5秒
		this.interval2 = setInterval(() => {
			_this.dataZoomAutoScoll();
		}, 1000 * 5);
	},
	methods: {
		showTable() {
			this.$emit("showBigEven", true);
		},
		dataZoomAutoScoll() {
			const max = this.total - 1;
			if (pageSize < this.total) {
				if (this.end > max || this.start > max - pageSize) {
					this.start = 0;
					this.end = pageSize - 1;
				} else {
					this.start += 1;
					this.end += 1;
				}
				attendInfoByTodayChart.dispatchAction({
					type: 'dataZoom',
					dataZoomIndex: 0,
					startValue: this.start,
					endValue: this.end
				});
			}
		},
		initData() {
			let _this = this;
			// 基于准备好的dom，初始化echarts实例
			attendInfoByTodayChart = echarts.init(document.getElementById("mess_info"));
			this.$http.get("/dataView/clubClass/edu/getOrgAttendStu?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					_this.total = result.xDatas.length;
					var option = {
						tooltip: {
							trigger: 'axis',
							formatter: function (params) {
								var relVal = params[0].name;
								for (var i = 0; i < params.length; i++) {
									relVal += '<br/>' + params[i].marker + '&nbsp;' + params[i].seriesName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params[i].value + '人</b>';
								}
								return relVal
							}
						},
						dataZoom: [{
							type: 'inside',
							startValue: _this.start,
							endValue: _this.end,
						}],
						xAxis: {
							type: 'category',
							data: result.xDatas,
							boundaryGap: true,
							axisLabel: {
								interval: 0,
								rotate: 25, // 角度
								formatter: function (value) {
									return (value.length > 6 ? (value.slice(0, 6) + "...") : value)
								},
								textStyle: {
									color: '#34deff',
									fontSize: fontSize(0.12)
								}
							}
						},
						grid: {
							left: "10%",
							top: "10%",
							bottom: "16%",
						},
						yAxis: {
							type: 'value',
							splitLine: {
								show: true,
								lineStyle: {
									width: 1,
									color: 'rgba(255, 255, 255, 0.2)',
								}
							},
							axisLabel: {
								textStyle: {
									color: '#34deff',
									fontSize: fontSize(0.12)
								}
							},
							axisLine: {
								show: true
							},
						},
						series: [
							{
								name: '应出勤',
								type: 'bar',
								data: result.ydatas1,
								itemStyle: {
									//柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
									normal: {
										//柱形图圆角，初始化效果
										barBorderRadius: [20],
										color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
											offset: 0,
											color: "rgb(50, 220, 220)" // 0% 处的颜色
										}, {
											offset: 1,
											color: "rgb(48, 232, 217,0.6)" // 100% 处的颜色
										}], false)
									}
								},
								barGap: '0%',
								barWidth: 12
							},
							{
								name: '实际出勤',
								type: 'bar',
								data: result.ydatas2,
								itemStyle: {
									//柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
									normal: {
										//柱形图圆角，初始化效果
										barBorderRadius: [20],
										color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
											offset: 0,
											color: "rgb(231, 216, 7)" // 0% 处的颜色
										}, {
											offset: 1,
											color: "rgb(255, 150, 2)" // 100% 处的颜色
										}], false)
									}
								},
								barGap: '5%',
								barWidth: 12
							}
						]
					};
					attendInfoByTodayChart.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => attendInfoByTodayChart.resize(), false);
				}
			});
		}
	},
	destroyed() {
		window.onresize = null;
	}
};

function fontSize(res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
}
</script>

<style lang="scss">
#cc_right1 {
	height: 100%;

	.cc-header {

		width: 100%;
		text-align: center;
		background: url("../../assets/img/ac_titbgsmall.png") center no-repeat;
		background-size: 100%;
		color: #0ef3ff;
		font-size: 0.22rem;
		font-weight: bold;
		height: 0.8rem;
		line-height: 0.6rem;

		.title_tab {
			position: absolute;
			left: 0.3rem;
			top: 0.7rem;
			font-size: 0.18rem;
			height: 0.2rem;
			display: flex;
			align-items: center;

			.legend-color {
				display: inline-block;
				width: 0.25rem;
				height: 0.15rem;
				border-radius: 15%;
				margin-right: 0.05rem;
			}
		}

		.view_btn {
			position: absolute;
			right: 0.3rem;
			top: 0.6rem;
			display: inline-block;
			cursor: pointer;
			width: 1rem;
			height: 0.35rem;
			line-height: 0.35rem;
			border-radius: 0.08rem;
			border: 0.01rem solid #34deff;
			background-image: linear-gradient(135deg, #0c2d5f, #2e3b90);
			color: #34deff;
			font-size: 0.15rem;
			z-index: 1;
		}
	}

	.main-value {
		height: 85%;
		padding-left: 1%;
	}

}
</style>